export default __webpack_public_path__ + "static/media/me3_Diploma.0a34c204.svg";